// src/components/HeroMedia.tsx
export default function HeroMedia() {
  return (
    <div className="aspect-[16/11] w-full overflow-hidden rounded-2xl border border-border shadow-[0_10px_30px_rgba(0,0,0,0.06)]">
      <img
        src="/market-screenshot.png"  // already in /public
        alt="Siimply trading interface preview"
        className="h-full w-full object-cover"
        loading="lazy"
      />
    </div>
  );
}
